export default "__VITE_ASSET__B10R8VYr__"